// function extractPlainText(onlyDocumentContent = "") {
//     if (!onlyDocumentContent) return "";

//     let normalizedContent = onlyDocumentContent;

//     try {
//         const parsedContent = JSON.parse(onlyDocumentContent);
//         if (parsedContent?.blocks && Array.isArray(parsedContent.blocks)) {
//             return parsedContent.blocks
//                 .map((block) => block?.text || "")
//                 .join("\n")
//                 .trim();
//         }
//     } catch (error) {
//         // Content is HTML/plain text, so continue with HTML extraction.
//     }

//     normalizedContent = normalizedContent
//         .replace(/<br\s*\/?>/gi, "\n")
//         .replace(/<\/p>/gi, "\n")
//         .replace(/<div\s*\/?>/gi, "\n")
//         .replace(/<\/div>/gi, "\n");

//     const tempElement = document.createElement("div");
//     tempElement.innerHTML = normalizedContent;

//     return (tempElement.innerText || tempElement.textContent || "").trim();
// }



// function getLatestPreviewText(textContent, previewLength = 120) {
//     const paragraphs = textContent
//         .split("\n")
//         .map((line) => line.trim())
//         .filter(Boolean);

//     if (paragraphs.length === 0) return "";

//     let previewText = "";
//     for (let i = paragraphs.length - 1; i >= 0; i -= 1) {
//         const candidate = previewText
//             ? `${paragraphs[i]} ${previewText}`
//             : paragraphs[i];

//         previewText = candidate;
//         if (previewText.length >= previewLength) break;
//     }

//     if (previewText.length <= previewLength) {
//         return previewText;
//     }

//     return `...${previewText.slice(previewText.length - previewLength).trim()}`;
// }

// export function getTextFromEditorState(onlyDocumentContent, sliceIt) {
//     const textContent = extractPlainText(onlyDocumentContent);

//     if (sliceIt) {
//         return getLatestPreviewText(textContent, 120);
//     }

//     return textContent;
// }




function extractPlainText(content = "") {
    if (!content) return "";

    let parsed = content;

    // ✅ Handle string OR object safely
    if (typeof content === "string") {
        try {
            parsed = JSON.parse(content);
        } catch {
            parsed = content;
        }
    }

    // ✅ DraftJS RAW format
    if (parsed?.blocks && Array.isArray(parsed.blocks)) {
        return parsed.blocks
            .map(block => block.text || "")
            .join("\n")
            .trim();
    }

    // ✅ HTML fallback
    if (typeof parsed === "string") {
        const normalized = parsed
            .replace(/<br\s*\/?>/gi, "\n")
            .replace(/<\/p>/gi, "\n")
            .replace(/<p[^>]*>/gi, "")
            .replace(/<\/div>/gi, "\n")
            .replace(/<div[^>]*>/gi, "");

        const temp = document.createElement("div");
        temp.innerHTML = normalized;

        return (temp.textContent || "").trim();
    }

    return "";
}

function getLatestPreviewText(text, length = 120) {
    if (!text) return "";

    const clean = text.replace(/\s+/g, " ").trim();

    if (clean.length <= length) return clean;

    return "..." + clean.slice(-length);
}

export function getTextFromEditorState(content, sliceIt) {
    const text = extractPlainText(content);
    return sliceIt ? getLatestPreviewText(text) : text;
}